<template>
	<section class="app-container">
		<h1>Prices</h1>
		<div class="price-card" v-for="(grp, i) in groupedPrices" :key="i">
			<h4 class="price-card__group">
				{{ kebabToTitleCase(grp.group === 'none' ? 'other' : grp.group) }}
			</h4>
			<div
				class="price-card__service"
				v-for="(ser, j) in grp.services"
				:key="j"
			>
				<div class="price-card__header">
					<span class="price-card__th">{{ ser.name }}</span>
					<span class="price-card__th">{{
						hasTarget[i][j].length > 0 ? 'Target' : ''
					}}</span>
					<span class="price-card__th">Unit</span>
					<span class="price-card__th">Price</span>
				</div>
				<div class="price-card__body">
					<div class="price-card__row" v-for="(p, k) in ser.prices" :key="k">
						<span class="price-card__td">{{
							camelToTitleCase(p.metric) + ' ' + p.measure
						}}</span>
						<span class="price-card__td">{{ p.target }}</span>
						<span class="price-card__td">{{
							metricUsageFormat(p.units, p.measure)
						}}</span>
						<span class="price-card__td">$ {{ centsToDollars(p.cents) }}</span>
					</div>
				</div>
			</div>
		</div>
		<NoData v-if="groupedPrices && groupedPrices.lenght === 0" />
		<ErrorAlert :error="error" v-if="error" />
		<Spinner v-if="loading" />
	</section>
</template>

<script>
import ErrorAlert from '../shared/ErrorAlert';
import Spinner from '../shared/Spinner';
import NoData from '../shared/NoData';
import TextHelpers from '../../util/helper-functions';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'Prices',
	components: {
		ErrorAlert,
		Spinner,
		NoData,
	},
	data() {
		return {
			error: null,
			prices: {},
			loading: false,
		};
	},
	mounted() {
		this.fetchServices();
	},
	methods: {
		...mapActions({
			fetchServices: 'fetchServices',
		}),
		kebabToTitleCase(text) {
			return TextHelpers.kebabToTitleCase(text);
		},
		kebabToPascalCase(text) {
			return TextHelpers.kebabToPascalCase(text);
		},
		camelToTitleCase(text) {
			return TextHelpers.camelToTitleCase(text);
		},
		centsToDollars(num) {
			return (num / 100).toFixed(2);
		},
		metricUsageFormat(v, f) {
			if (!this.usageFormats) {
				this.usageFormats = {
					count: function (v) {
						return `${v.toLocaleString()} #`;
					},
					bytes: function (v) {
						var m = 'b';
						if (v > 1024) {
							v = v / 1024;
							if (v > 1024) {
								v = v / 1024;
								if (v > 1024) {
									v = v / 1024;
									m = 'Gb';
								} else {
									m = 'Mb';
								}
							} else {
								m = 'kb';
							}
							return `${v.toFixed(2)} ${m}`;
						} else {
							return `${v} ${m}`;
						}
					},
					time: function (v) {
						var m = 'ms';
						if (v > 1000) {
							v = v / 1000;
							if (v > 60) {
								v = v / 60;
								if (v > 60) {
									v = v / 60;
									m = 'h';
								} else {
									m = 'min';
								}
							} else {
								m = 's';
							}
							return `${v.toFixed(2)} ${m}`;
						} else {
							return `${v} ${m}`;
						}
					},
				};
			}
			return this.usageFormats[f](v);
		},
	},
	computed: {
		...mapGetters({
			groupedPrices: 'groupedUserPrices',
		}),
		hasTarget() {
			return this.groupedPrices.map((gp) =>
				gp.services.map((s) => s.prices.map((p) => p.target).filter((t) => t)),
			);
		},
	},
};
</script>

<style scoped>
.prices-wrapper {
	height: calc(100% - 60px);
	overflow: auto;
}
.price-card {
	border: 1px solid #cecdcd;
	padding: 2rem;
	max-width: 87.5rem;
	margin-bottom: 2.5rem;
}
.price-card__group {
	font-weight: normal;
	color: #c78500;
}
.price-card__service {
	margin-top: 2rem;
}
.price-card__header {
	font-weight: bold;
	display: block;
	width: 100%;
	padding: 1rem;
	border-bottom: 1px solid #b8b8b8;
}
.price-card__th {
	display: inline-block;
	width: 20%;
	font-size: 1.2rem;
	text-transform: uppercase;
}
.price-card__th:first-child {
	width: 40%;
	text-transform: none;
	font-size: 1.4rem;
}
.price-card__td {
	display: inline-block;
	width: 20%;
	font-size: 1.4rem;
}
.price-card__td:first-child {
	width: 40%;
}
.price-card__body {
	padding: 1rem;
}
</style>
